import * as actions from "../actions";
import * as api from "../../api";
import { pushSourceToken } from 'utils';

export const getFacturationStatistics = (app, appRef, issuerId, year, appType) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_FACTURATION_STATISTICS", dispatch);

    const {token} = getState().auth;
    return dispatch(actions.getFacturationStatistics(api.getFacturationStatistics(token,app, appRef, issuerId, year, appType, sourceToken)));
  };
};

export const getPaymentStatistics = (app, appRef, issuerId, year, appType) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_PAYMENT_STATISTICS", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.getPaymentStatistics(api.getPaymentStatistics(token,app, appRef, issuerId, year, appType, sourceToken)));
  };
};

export const getNotPaidInvoices = (app, appRef, issuerId, year, appType) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_NOT_PAID_INVOICES", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.getNotPaidInvoices(api.getNotPaidInvoices(token,app, appRef, issuerId, year, appType, sourceToken)));
  };
};

export const getRecapByDay = (app, appRef, operationType, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getRecapByDay(api.getRecapByDay(token,app, appRef, operationType, issuerId, year, appType)));
  };
};

export const getInvoiceByEventDetails = (app, appRef, operationType, day, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getInvoiceByEventDetails(api.getInvoiceByEventDetails(token,app, appRef, operationType, day, issuerId, year, appType)));
  };
};

export const getUnpaidInvoicesDetails = (app, appRef, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getUnpaidInvoicesDetails(api.getUnpaidInvoicesDetails(token,app, appRef, issuerId, year, appType)));
  };
};

export const displayCsvFile = (app, appRef, operationType, day, search, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.displayCsvFile(token, app, appRef, operationType, day, search, issuerId, year, appType);
  };
};

export const displayNotPaidInvoicesCsvFile = (app, appRef, search, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.displayNotPaidInvoicesCsvFile(token, app, appRef, search, issuerId, year, appType);
  };
};


export const displayRecapPaymentCsvFile = (app, appRef, operationType, date, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.displayRecapPaymentCsvFile(token, app, appRef, operationType, date, issuerId, year, appType);
  };
};

export const displayPdfPaidInvoicesFile = (app, appRef, operationType, day, search, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.displayPdfPaidInvoicesFile(token, app, appRef, operationType, day, search, issuerId, year, appType);
  };
};

export const displayNotPaidInvoicesPdfFile = (app, appRef, search, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.displayNotPaidInvoicesPdfFile(token, app, appRef, search, issuerId, year, appType);
  };
};

export const displayRecapPaymentPdfFile = (app, appRef, operationType, date, issuerId, year, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.displayRecapPaymentPdfFile(token, app, appRef, operationType, date, issuerId, year, appType);
  };
};


export const getDocumentsToBeExportedZipEfff = (app, appRef, issuerId, year, discriminat, appType) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getDocumentsToBeExportedZipEfff(api.getDocumentsToBeExportedZipEfff(token,app, appRef, issuerId, year, discriminat, appType)));
  };
};

export const startCommandExportEfffZip = (app, appRef, issuerId, year, discriminat, zipType, appType, isXml) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.startCommandExportEfffZip(api.startCommandExportEfffZip(token,app, appRef, issuerId, year, discriminat, zipType, appType, isXml)));
  };
};

export const getCommandInfo = (commandId) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return api.getCommandInfo(token, commandId);
  };
};

export const getDoublePayment = (app, appRef, issuerId, year, appType) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("GET_DOUBLE_PAYMENT", dispatch);
    const {token} = getState().auth;
    return dispatch(actions.getDoublePayment(api.getDoublePayment(token,app, appRef, issuerId, year, appType, sourceToken)));
  };
};

export const removeDoublePaymentFromDatatable = (recordId) => {
  return (dispatch, getState) => {
    return dispatch(actions.removeDoublePaymentFromDatatable(recordId));
  };
};

export const changeRefundedOrderStatus = (orderIds) => {
  return (dispatch, getState) => {
    return dispatch(actions.changeRefundedOrderStatus(orderIds));
  };
};

export const startCommandGetCANbrInscriptionByFormat = (frequency, period, languages, isComparison = false) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return dispatch(actions.startCommandGetCANbrInscriptionByFormat(api.startCommandGetCANbrInscriptionByFormat(token, currentClient.id, frequency, period, languages)));
  };
};

export const startCommandCumulateByFormat = (frequency, period, languages, type) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return dispatch(actions.startCommandCumulateByFormat(api.startCommandCumulateByFormat(token, currentClient.id,  period, frequency, languages, type)));
  };
}

export const getNbrCotisants = (period) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getNbrCotisants(api.getNbrCotisants(token, period)));
  };
}

export const getTypeFormats = (period) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getTypeFormats(api.getTypeFormats(token, period)));
  };
}

export const getNbrCotisantByFormat = (period, frequency, month) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getNbrCotisantByFormat(api.getNbrCotisantByFormat(token, period, frequency, month)));
  };
};

export const getCAByFormat = (period, frequency, month) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getCAByFormat(api.getCAByFormat(token, period, frequency, month)));
  };
};

export const getCotisationMonths = (period) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getCotisationMonths(api.getCotisationMonths(token, period)));
  };
};

export const getMembershipAssociative = (period, frequency, month) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getMembershipAssociative(api.getMembershipAssociative(token, period, frequency, month)));
  }
}

export const getActivePremium = (period, frequency, startMonth, endMonth) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return dispatch(actions.getActivePremium(api.getActivePremium(token, currentClient.id, period, frequency, startMonth, endMonth)));
  };
}

export const getAccumulateStats = (period, frequency, month, type) => {
  return (dispatch, getState) => {
    const {token} = getState().auth;
    return dispatch(actions.getAccumulateStats(api.getAccumulateStats(token, period, frequency, month, type)));
  };
}

export const getAccumulateEventStats = (frequency, period, languages, type) => {
  return (dispatch, getState) => {
    const {token, currentClient} = getState().auth;
    return dispatch(actions.getAccumulateEventStats(api.getAccumulateEventStats(token, currentClient.id, frequency, period, languages, type)));
  };
}


// WEBPACK FOOTER //
// ./app/actions/thunks/statistics.js